import React, { Component } from 'react';
import * as styled from '../../styles/style';
import EventForm from '../forms/EventForm';
import FormWrapper from '../forms/FormWrapper';
import days from '../../helpers/countdown';
import { errorMessages } from '../../helpers/validation';
import Loadable from 'react-loadable';
import Loading from '../Loading'
let bcrypt = require('bcryptjs');

const Map = Loadable({
  loader: () => import('./Map'),
  loading: Loading,
  delay: 300,
})

const Chart = Loadable({
  loader: () => import('./Chart'),
  loading: Loading,
  delay: 300,
})

class AdminEventsDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      error: ''
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();

    let user = { ...this.props.selectedUser };
    let event = { ...this.props.selectedEvent };

    if (this.form.state.user.password !== undefined) {
      user.password_digest = bcrypt.hashSync(this.form.state.user.password, 8);
    }

    this.validateFormState();
    this.props.updateUser(user);
    this.props.updateEvent(event);
    this.setState({
      error: ''
    })
  }

  validateFormState = () => {
    // check for empty required fields
    const {
      postal_code,
      swag,
      swag_address_1,
      swag_city,
      swag_postal,
      swag_guests,
    } = this.form.state.event;
    if (!postal_code) {
      this.form.setWarningMessage('postal_code', errorMessages['postal_code_required']);
      return false;
    }
    if (swag) {
      if (!swag_address_1) {
        this.form.setWarningMessage('swag_address_1', errorMessages['swag_address_1'])
      }
      if (!swag_city) {
        this.form.setWarningMessage('swag_city', errorMessages['swag_city'])
      }
      if (!swag_postal) {
        this.form.setWarningMessage('swag_postal', errorMessages['postal_code_required'])
      }
      if (!swag_guests) {
        this.form.setWarningMessage('swag_guests', errorMessages['swag_guests'])
      }
    }

    const { firstname, lastname, email } = this.form.state.user;
    if (!firstname) {
      this.form.setWarningMessage('firstname', errorMessages['firstname']);
      return false;
    }
    if (!lastname) {
      this.form.setWarningMessage('lastname', errorMessages['lastname']);
      return false;
    }
    if (!email) {
      this.form.setWarningMessage('email', errorMessages['email']);
      return false;
    }

    // check for any fields in error state
    let warnings = this.form.state.warnings;

    if (Object.keys(warnings).length === 0) {
      return true;
    }
    for (let warning in warnings) {
      if (warnings[warning] !== undefined && warnings[warning] !== '') {
        return false;
      }
    }
    return true;
  }

  render() {
    let { selectedEvent, selectedUser} = this.props;

    if (selectedEvent) {
      return (
        <styled.AdminContent>
          <h1>{selectedEvent.name}</h1>
          <form style={{display: 'flex', flexDirection: 'column'}}>
            <styled.AdminScroll>
              <EventForm ref={(form) => {this.form = form}} admin={true} event={selectedEvent} user={selectedUser} clearAlert={this.props.clearAlert} />
            </styled.AdminScroll>
            <styled.ButtonNotificaton>
              <styled.Button type="submit" value='Save' onClick={this.handleSubmit} />
              <styled.ErrorMessage>{this.state.error}</styled.ErrorMessage>
            </styled.ButtonNotificaton>
          </form>
        </styled.AdminContent>
      )
    }
    else {
      var swag_bags = this.props.events.map(function(event) { return event.swag_guests ? Math.ceil(parseInt(event.swag_guests.split('-').pop(), 10) / 12) : 0 }).reduce(function(accumulator, currentValue) { return accumulator + currentValue }, 0);
      return (
        <styled.AdminContent>
          {days > 0 && (<styled.Countdown>{days} day{days > 1 ? 's' : ''} to On the Table</styled.Countdown>)}
          <h2>Showing {this.props.events && this.props.events.length} hosts</h2>
          {/*<h2 style={{marginTop: 0}}>{swag_bags} swag bags requested / {200 - swag_bags} swag bags remaining</h2>*/}
          {this.props.events && (<Chart events={this.props.events}/>)}
          {this.props.events && (<Map events={this.props.events} onSelectedChange={this.props.onSelectedChange}/>)}
        </styled.AdminContent>
      )
    }
  }
}

export default AdminEventsDetail
